<template>
  <div class="main">
    <div class="main_header">
      <div class="header_item">
        <span class="header_label">托盘名称：</span>
        <el-select v-model="search.trayId" clearable placeholder="请选择托盘名称">
                <el-option
                v-for="item in optionsTray"
                :key="item.trayId"
                :label="item.trayName"
                :value="item.trayId">
                </el-option>
            </el-select>
      </div>
      <div class="header_item">
        <span class="header_label">项目名称：</span>
        <el-select v-model="search.chainProjectId" placeholder="请选择项目名称" clearable>
                <el-option
                v-for="item in optionsProject"
                :key="item.chainProjectId"
                :label="item.chainProjectName"
                :value="item.chainProjectId">
                </el-option>
            </el-select>
      </div>
      <div class="header_item">
        <el-button icon="el-icon-search" v-if="showButton('search')" @click="searchButtonInfo(true)">查询</el-button>
        <el-button class="search_btn" icon="el-icon-plus" v-if="showButton('insert')" @click="insertProp">新增</el-button>
        <!-- <el-button icon="el-icon-upload2" v-if="showButton('export')" @click="exportBigData">导出Excel</el-button> -->
      </div>
    </div>
    <div class="main_content">
      <el-table
        v-loading="loading"
        :data="dataList"
        height="100%">
        <el-table-column align="center" label="序号" width="60">
          <template #default="scope">
            <span>{{(pageNum - 1) * pageSize + scope.$index + 1}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="trayId" label="托盘名称" align="center" >
            <template #default="{ row }">
                {{getName(row, optionsTray)}}
            </template>
        </el-table-column>
        <el-table-column prop="chainProjectId" label="项目名称" align="center" >
            <template #default="{ row }">
                {{getName1(row, optionsProject)}}
            </template>
        </el-table-column>
        <el-table-column prop="blockNum" label="块数" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="moldingTime" label="入模时间" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="moldRelease" label="出模时间" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="occupyTypeName" label="状态名称" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column label="操作" align="center" width="200">
          <template #default="{ row }">
            <el-button class="table_btn" size="mini" v-if="showButton('update')" @click="outMold(row)">出模</el-button>
            <el-button class="table_btn" size="mini" v-if="showButton('update')" @click="updateProp(row)">查看班组</el-button>
            <!-- <el-button class="delete_btn" size="mini" v-if="showButton('delete')" @click="deleteInfo(row)">删除</el-button> -->
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="main_footer">
      <el-pagination
        background
        @current-change="changePageNum"
        @size-change="changePageSize"
        :current-page="pageNum"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <el-dialog
      class="prop_dialog"
      :title="asyncTitle? '新增连锁块' :'修改连锁块'"
      :close-on-click-modal="false"
      :visible.sync="asyncVisible"
      width="45%">
      <el-form ref="ruleForm" :model="ruleForm" :rules="rules" label-width="auto" class="rule_form">
        <el-form-item label="托盘名称：" prop="trayId">
         <el-select v-model="ruleForm.trayId" placeholder="请选择托盘名称" clearable>
                <el-option
                v-for="item in optionsTray"
                :key="item.trayId"
                :label="item.trayName"
                :value="item.trayId">
                </el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="项目名称：" prop="chainProjectId">
         <el-select v-model="ruleForm.chainProjectId" placeholder="请选择项目名称" clearable>
                <el-option
                v-for="item in optionsProject"
                :key="item.chainProjectId"
                :label="item.chainProjectName"
                :value="item.chainProjectId">
                </el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="块数：" prop="blockNum">
            <el-input-number v-model="ruleForm.blockNum" placeholder="请输入块数" :min="1" :max="18" ></el-input-number>
        </el-form-item>
        <el-form-item label="状态名称：" prop="occupyType">
            <el-select v-model="ruleForm.occupyType" placeholder="请选择状态名称" clearable>
                <el-option
                v-for="item in optionsType"
                :key="item.dictId"
                :label="item.dictName"
                :value="item.dictId">
                </el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="入模时间" prop="moldingTime" v-if="ruleForm.occupyType === 1">
          <el-date-picker
                v-model="ruleForm.moldingTime"
                type="date"
                style="width:100%"
                value-format="yyyy-MM-dd"
                placeholder="请选择入模时间">
            </el-date-picker>
        </el-form-item>
        <el-form-item label="出模时间" prop="moldRelease" v-if="ruleForm.occupyType === 2">
          <el-date-picker
                v-model="ruleForm.moldRelease"
                type="date"
                style="width:100%"
                value-format="yyyy-MM-dd"
                placeholder="请选择出模时间">
            </el-date-picker>
        </el-form-item>
        <template v-for="(item,index) in groupList">
          <el-form-item :key="index" :label="item.teamName" prop="" class="radio-form-item">
            <el-radio-group v-model="item.userType">
              <el-radio :label="'1'">白班</el-radio>
              <el-radio :label="'2'">夜班</el-radio>
            </el-radio-group>
          </el-form-item>
        </template>
      </el-form>
      <div slot="footer">
        <el-button @click="asyncVisible = false">取 消</el-button>
        <el-button class="submit_btn" @click="asyncTitle ? submitInsert() : submitUpdate()">提 交</el-button>
      </div>
    </el-dialog>
    <!-- 查看班组 -->
    <el-dialog
      class="prop_dialog"
      title="班组信息"
      :close-on-click-modal="false"
      :visible.sync="asyncVisibleGroup"
      width="45%">
      <div class="group-container">
        <div class="group-header">
          <div class="group-header-item">工序班组</div>
          <div class="group-header-item">白班人员</div>
          <div class="group-header-item">夜班人员</div>
        </div>
        <div v-for="item in groupList" :key="item.teamId" class="group-row">
          <div class="group-cell group-name">{{item.teamName}}</div>
          <div class="group-cell">
            <el-tag
              v-for="user in (item.teamUserList || []).filter(u => u.userType === 1)"
              :key="'day-' + user.userId"
              class="person-tag day"
            >{{user.userName}}</el-tag>
            <span v-if="!(item.teamUserList || []).filter(u => u.userType === 1).length" class="empty-text">-</span>
          </div>
          <div class="group-cell">
            <el-tag
              v-for="user in (item.teamUserList || []).filter(u => u.userType === 2)"
              :key="'night-' + user.userId"
              class="person-tag night"
            >{{user.userName}}</el-tag>
            <span v-if="!(item.teamUserList || []).filter(u => u.userType === 2).length" class="empty-text">-</span>
          </div>
        </div>
      </div>
      <div slot="footer">
        <!-- <el-button @click="asyncVisibleGroup = false">取 消</el-button> -->
        <!-- <el-button class="submit_btn" @click="asyncTitle ? submitInsert() : submitUpdate()">提 交</el-button> -->
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { buttonPinia } from '../../pinia/index';
import { throttle, changeSize, downFiles } from '../../plugins/public'; // 导入节流、动态切换组件尺寸方法
  export default {
    data() {
      return {
        size: changeSize(), // 组件尺寸
        pageNum: 1,
        pageSize: 10,
        search:{},//查询条件
        total: 0,
        loading: false,
        dataList: [], //托盘信息列表
        rowIds: null, //选中的行id
        asyncTitle: true, // 对话框title 新增：true  修改：false
        asyncVisible: false, // 添加 修改对话框
        asyncVisibleGroup: false, // 查看班组对话框
        groupList: [], //班组信息列表
        ruleForm: {
            trayName: '',
            useNumber: 0,
            isOccupy: '',
        }, // 按钮表单
        rules: {
          trayId: [{
            required: true,
            message: '请选择托盘名称',
            trigger: 'blur'
          }],
          chainProjectId: [{
            required: true,
            message: '请选择项目名称',
            trigger: 'blur'
          }],
          occupyType: [{
            required: true,
            message: '请选择状态名称',
            trigger: 'change'
          }],
          blockNum: [{
            required: true,
            message: '请输入块数',
            trigger: 'blur'
          }],
          moldingTime: [{
            required: true,
            message: '请选择入模时间',
            trigger: 'change'
          }],
          moldRelease: [{
            required: true,
            message: '请选择出模时间',
            trigger: 'change'
          }],
        },
        optionsTray: [], //托盘名称
        optionsProject: [], //项目名称
        groupList: [], //班组信息列表
        optionsType: [
            {
                dictId: 1,
                dictName: '入模',
            },
            {
                dictId: 2,
                dictName: '出模',
            },
        ], //是否占用状态
      }
    },
    watch: {
      asyncVisible(bol) {
        if(!bol) {
          this.ruleForm = {};
          this.$refs.ruleForm.resetFields();
        }
      }
    },
    mounted() {
      const that = this;
      // 根据窗口大小动态修改组件尺寸
      window.onresize = () => {
        that.size = changeSize();
      }
      that.searchButtonInfo(true);
      that.getAllTypes()
      that.getAllProject()
      that.getAllGroups()
    },
    methods: {
      //获取所有班组
			async getAllGroups(){
				const { data } = await this.$api.Group.searchGroupList({
					  pageNum: 1,
					  pageSize: 1000000
				});
				data.list.map(item=>{
					this.groupList.push({
						teamName:item.teamName,
						teamId:item.teamId,
						userType:'1',
						teamUserList:item.teamUserList
					})
				})
				
			},
        //根据id获取名称
        getName(row, options) {
            let name = options.find(item => item.trayId === row.trayId)?.trayName || '-';
            return name;
        },
        //根据id获取项目名称
        getName1(row, options) {
            let name = options.find(item => item.chainProjectId === row.chainProjectId)?.chainProjectName || '-';
            return name;
        },
    //     //获取所有托盘信息
      getAllTypes(){
        let params = {
            pageNum: 1,
            pageSize: 100000000,
        }
        this.loading = true;
        this.$api.Tray.searchTrayList(params).then((res) => {
          if(res.statusMsg === 'ok') {
            this.optionsTray = res.data.list;
          }
        })
      },
      //获取所有项目信息
      getAllProject(){
        let params = {
            pageNum: 1,
            pageSize: 100000000,
        }
        this.$api.Chain.searchChainProjectList(params).then((res) => {
          if(res.statusMsg === 'ok') {
            this.optionsProject = res.data.list;
          }
        })
      },
      
    // 转圈圈
    functionLoading() {
        this.loadingView = this.$loading({
            lock: true,
            text: '请稍后...',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
        });
    },
    //导出Excel
    exportBigData(){
        this.functionLoading();
        let params  = Object.assign({},this.search)
        this.$api.Tray.exportTrayDatas(params).then(res => {
            downFiles(res, '托盘信息', 'xls')
            this.loadingView.close()
        })
        .catch(() => {
          this.loadingView.close();
        })
    },
      // 查询按钮列表信息
      searchButtonInfo(bol) {
        if(bol) {
          this.pageNum = 1;
        }
        let params = Object.assign({},this.search,{
          pageNum: this.pageNum,
          pageSize: this.pageSize
        })
        this.loading = true;
        this.$api.Block.searchBlockList(params).then((res) => {
          if(res.statusMsg === 'ok') {
            this.total = res.data.total;
            this.dataList = res.data.list;
          }
          this.loading = false;
        })
      },
      // 新增按钮信息
      insertProp() {
        this.asyncTitle = true;
        this.asyncVisible = true;
      },
      // 查看班组
      updateProp(row) {
        this.asyncVisibleGroup = true;
        this.rowIds = row.chainBlockId;
        this.$api.Block.detailsBlockGroup({chainBlockId: row.chainBlockId}).then(res => {
          if(res.statusMsg === 'ok') {
            this.groupList = res.data;
          } else {
            this.$message.warning(res.statusMsg);
          }
        })
        // this.$api.Tray.detailsTrayDevice({trayId: row.trayId}).then(res=>{
        //     if(res.statusMsg === 'ok'){
        //         this.ruleForm = res.data
        //     }else{
        //         this.$message.warning(res.statusMsg)
        //     }
        // })
      },
      // 出模
      outMold(row) {
        let obj = Object.assign({}, row,{
          occupyType:2
        })
        this.$api.Block.insertBlockOrUpdate(obj).then(res => {
          if(res.statusMsg === 'ok') {
            this.searchButtonInfo(true);
            this.$message.success("出模成功！");
          } else {
            this.$message.warning(res.statusMsg);
          }
        })
      },
      // 删除按钮信息
      deleteInfo(row) {
        this.$confirm("该操作将删除该信息，是否继续删除?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
       })
       .then(() => {
         this.$api.Block.deleteBlockDevice({chainBlockId: row.chainBlockId})
        .then(res => {
          if(res.statusMsg === 'ok') {
            this.searchButtonInfo(true);
            this.$message.success("删除成功！");
          } else {
            this.$message.warning(res.statusMsg);
          }
        })
       })
       .catch(() => {
         this.$message.warning("您已取消");
       })
      },
      // 提交添加按钮信息
      submitInsert: throttle(function() {
        this.$refs.ruleForm.validate((valid) => {
          if(valid) {
            const params = Object.assign({}, this.ruleForm);
            params.blockTeamList = this.groupList.map(item => {
              return {
                ...item,
                teamUserList: (item.teamUserList || []).filter(user => String(user.userType) === String(item.userType))
              }
            });
            this.$api.Block.insertBlockOrUpdate(params).then((res) => {
              if(res.statusMsg === 'ok') {
                this.asyncVisible = false;
                this.searchButtonInfo(true);
                this.$message.success('添加成功！');
              } else {
                this.$message.warning(res.statusMsg);
              }
            })
          }
        })
      }, 3000),
      // 提交修改按钮信息
      submitUpdate: throttle(function() {
        this.$refs.ruleForm.validate((valid) => {
          if(valid) {
            const params = Object.assign({}, this.ruleForm,{
              chainBlockId: this.rowIds
            });
            this.$api.Block.insertBlockOrUpdate(params).then((res) => {
              if(res.statusMsg === 'ok') {
                this.asyncVisible = false;
                this.searchButtonInfo(true);
                this.$message.success('修改成功！');
              } else {
                this.$message.warning(res.statusMsg);
              }
            })
          }
        })
      }, 3000),
      // 判断按钮权限信息
      showButton(str) {
        const pinia = buttonPinia();
        return pinia.$state.buttonInfo.includes(str);
      },      
      // 切换页数
      changePageNum(page) {
        this.pageNum = page;
        this.searchButtonInfo();
      },
      // 切换每页条数
      changePageSize(size) {
        this.pageSize = size;
        this.searchButtonInfo();
      }
    }
  }
</script>

<style lang="scss" scoped>
@import '../../style/layout-main.scss';
.el-radio{
  padding-bottom: 0px!important;
}
.group-container {
  width: 100%;
  border: 1px solid #1c5a7f;
  border-radius: 4px;
  overflow: hidden;
}

.group-header {
  display: flex;
  border-bottom: 1px solid #1c5a7f;
  background: linear-gradient(
    0deg,
    transparent 5%,
    rgba(57, 181, 254, .5) 95%);
}

.group-header-item {
  flex: 1;
  padding: 15px 0;
  font-weight: 500;
  font-size: 14px;
  text-align: center;
  color: #39B5FE;
  border-right: 1px solid #1c5a7f;

  &:last-child {
    border-right: none;
  }
}

.group-row {
  display: flex;
  border-bottom: 1px solid #1c5a7f;

  &:last-child {
    border-bottom: none;
  }
}

.group-cell {
  flex: 1;
  padding: 16px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  min-height: 60px;
  border-right: 1px solid #1c5a7f;

  &:last-child {
    border-right: none;
  }
}

.group-name {
  justify-content: center;
  font-weight: 500;
  color: #fff;
}

.person-tag {
  margin: 0;
  border-radius: 4px;
  font-size: 13px;
  padding: 0 10px;
  height: 28px;
  line-height: 26px;

  &.day {
    background-color: transparent;
    border-color: #409eff;
    color: #fff;
  }

  &.night {
    background-color: transparent;
    border-color: #409eff;
    color: #fff;
  }
}

.empty-text {
  color: #909399;
  text-align: center;
  width: 100%;
}

::v-deep .radio-form-item {
  display: flex;
  align-items: center;
  .el-form-item__label {
    text-align: center;
  }
  .el-form-item__content {
    display: flex;
    align-items: center;
  }
}
</style>